import { ActionIcon } from '@any-ui-react/core';
import type { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { MaterialIcons } from '../../material-icons';
import { SkeletonLoader } from '../../skeleton-loader';

export interface PageTitleProps {
  aside?: () => ReactNode;
  loading?: boolean;
  text?: string;
  subText?: ReactNode;
  onBack?: () => void;
}

export const PageTitle = ({ aside, loading, text, subText, onBack }: PageTitleProps) => (
  <>
    <Helmet>
      <title>{text ? `${text} | AnyMind MED` : 'AnyMind MED'}</title>
    </Helmet>
    <div className="mb-4 flex flex-wrap items-center justify-between">
      <div className="flex items-center truncate">
        <SkeletonLoader height="1.125rem" loading={loading} width="12rem">
          {onBack && (
            <ActionIcon
              className="card mr-4 bg-white shadow-none focus:outline-none"
              variant="default"
              onClick={onBack}
            >
              <MaterialIcons iconName="keyboard_arrow_left" className="cursor-pointer" />
            </ActionIcon>
          )}
          <div>
            {text && <h3 className="truncate text-lg font-semibold">{text}</h3>}
            {subText}
          </div>
        </SkeletonLoader>
      </div>
      <div className="ml-auto">{aside?.()}</div>
    </div>
  </>
);
